module.exports = __webpack_public_path__ + "img/D201910_3.9f614056.jpg";